import React from 'react';

import { Box, Typography } from '@mui/material';
import ViewWeekOutlinedIcon from '@mui/icons-material/ViewWeekOutlined';

import { palette } from 'themeV5/palette';

import type { Column } from 'api/shared/models';

import ColumnOptions from '../ColumnOptions';
import { styles } from '../styles';

interface Props {
  columns: Column[];
  onClick: (column: Column) => void;
}

const AvailableColumns = ({ columns, onClick }: Props) => {
  return (
    <Box style={{ backgroundColor: palette.common.white }}>
      <Typography variant="h6" sx={styles.headerColumn}>
        <ViewWeekOutlinedIcon style={{ marginRight: 8 }} /> Columnas disponibles
      </Typography>
      <ColumnOptions
        columns={columns}
        onClick={onClick}
        addDragAndDrop={false}
      />
    </Box>
  );
};

export default AvailableColumns;
